import { useIntl } from "react-intl";
import { SegmentedControl } from "@/components/design/SegmentedControl";

type CommunityType = "person" | "company" | "post" | "project";

export function CommunityTypes({ value, onChange }: {
  value: CommunityType;
  onChange: (value: CommunityType) => void;
}) {
  const intl = useIntl();
  return <SegmentedControl
    id="community-type"
    value={value}
    onChange={onChange}
    fullWidth
    aria-label={intl.formatMessage({ id: "save.community.types", defaultMessage: "Community content" })}
    options={[
      { value: "person", label: intl.formatMessage({ id: "save.pinGroupSidebar.tabPerson", defaultMessage: "People" }) },
      { value: "company", label: intl.formatMessage({ id: "save.community.companies", defaultMessage: "Companies" }) },
      { value: "post", label: intl.formatMessage({ id: "save.pinGroupSidebar.tabPost", defaultMessage: "Posts" }) },
      { value: "project", label: intl.formatMessage({ id: "save.pinGroupSidebar.tabProject", defaultMessage: "Projects" }) },
    ]}
  />;
}
